import { Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * LabelNameInput component, this component is used for inputting label names and shows validation as passed in props
 * @props hasError,
 * @props item,
 * @props isFocused,
 * @props editMode,
 * @props onItemLabelChange,
 * @props labelNameValue,
 */

class LabelNameInput extends React.Component {
  onItemLabelValueChange = (e, item) => {
    const { onItemLabelChange, editMode } = this.props;

    onItemLabelChange(e, item, editMode);
  };

  render() {
    const { labelNameValue, item, isFocused, hasError } = this.props;
    return (
      <Input
        style={{ width: 100, borderColor: hasError ? 'red' : '' }}
        autoFocus={isFocused}
        placeholder="Label"
        onChange={(e) => this.onItemLabelValueChange(e, item)}
        defaultValue={labelNameValue}
      />
    );
  }
}

/**
 * Proptypes
 * @type {
 * hasError,
 * item,
 * isFocused,
 * editMode,
 * onItemLabelChange,
 * labelNameValue,
 * }
 */
LabelNameInput.propTypes = {
  hasError: PropTypes.string,
  item: PropTypes.object.isRequired,
  isFocused: PropTypes.bool.isRequired,
  editMode: PropTypes.string.isRequired,
  onItemLabelChange: PropTypes.func.isRequired,
  labelNameValue: PropTypes.string
};

export default LabelNameInput;
